module.exports = __webpack_public_path__ + "img/collar_edges_length.2b61a132.png";